import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import cn from 'classnames';
import ErrorMessage from 'shared/components/ErrorMessage';
import Tooltip from 'shared/components/Tooltip';
import styles from './Radio.module.scss';

const Radio = ({
  label,
  tooltip,
  value,
  error,
  checked,
  className,
  labelClassName,
  fullWidth,
  inverse,
  noMargin,
  size,
  ...props
}) => {
  const id = props.id || `${props.name || 'select'}-${Math.round(Math.random() * 10000)}`;
  const hasError = !!error;

  return (
    <>
      <div
        className={cn(
          styles.radio,
          className,
          styles[size],
          {
            [styles.fullWidth]: fullWidth,
            [styles.error]: hasError,
            [styles.inverse]: inverse,
            error: hasError
          }
        )}
      >
        <input type="radio" id={id} readOnly checked={checked} value={value} {...props} />
        <label htmlFor={id} className={cn(labelClassName, noMargin ? 'mb0' : undefined)}>{label}</label>
        {tooltip && (
          <Tooltip content={tooltip} />
        )}
      </div>
      {isString(error) && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

Radio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  fullWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  noMargin: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'large']),
};

Radio.defaultProps = {
  label: null,
  tooltip: null,
  value: null,
  checked: false,
  error: null,
  className: '',
  labelClassName: '',
  fullWidth: false,
  inverse: false,
  noMargin: false,
  size: 'default',
};

export default Radio;
